import api from './api';

export const getDashboardSummary = async () => {
  try {
    // const token = localStorage.getItem('token');
    // console.log(token);
    const response = await api.get('/dashboard/summary');
    // const response = await api.get('/dashboard/summary', {
    //   headers: {
    //     Authorization: `Bearer ${token}`
    //   }}
    // );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMapData = async (districtId = null, subdistrictId = null) => {
  try {
    const params = {};
    if (districtId) params.district_id = districtId;
    if (subdistrictId) params.subdistrict_id = subdistrictId;
    const response = await api.get('/dashboard/map-data', { params });
    // console.log('response.data:',response.data);
    // console.log('response.data.data:',response.data.data);
    return response.data.data;  // perubahan 2025/08/03 11:33:30
    // return response.data;  // aseli
  } catch (error) {
    throw error;
  }
};

export const getRegionStats = async () => {
  try {
    const response = await api.get('/dashboard/region-stats');
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getAssessmentSummary = async (regionId = null) => {
  try {
    const params = regionId ? { region_id: regionId } : {};
    const response = await api.get('/dashboard/assessment-summary', { params });
    return response.data.data;
  } catch (error) {
    throw error;
  }
}; 

export const getDashboardSummaryReport = async () => {
  const response = await api.get('/dashboard/summary-report');
  return response.data.data;
};

export const getRegionStatsReport = async (level = "kecamatan") => {
  const response = await api.get('/dashboard/region-stats-report', { params: { level } });
  return response.data.data;
};

export const getAssessmentSummaryReport = async (level = "kecamatan", regionId = null) => {
  const params = { level };
  if (regionId) params.region_id = regionId;
  const response = await api.get('/dashboard/assessment-summary-report', { params });
  return response.data.data;
};

export const getDistricts = async () => {
  const response = await api.get('/dashboard/districts');
  return response.data.data;
};

export const getSubDistricts = async (districtId = null) => {
  const response = await api.get('/dashboard/sub-districts', {
    params: districtId ? { district_id: districtId } : {}
  });
  return response.data.data;
};